const contentful = require("contentful");

export let client = contentful.createClient({
  space: "2zwo1qjcdnzd",
  accessToken: "7x3k3yBavTnfQNzxUuqT6HIsl0LbQHPkjlMCJkHJDI8"
});